// StoneX account hierarchy (mirrors the backend's stonex-accounts). The master
// is a consolidated view across both subs; trades book under the subs.
export const MASTER_ACCOUNT = 'LMM11727';
export const PRIMARY_SUB_ACCOUNT = 'LME11727';
// The ring-fenced Rivonia lender book.
export const LENDER_SUB_ACCOUNT = 'LME11728';
export const SUB_ACCOUNTS = [PRIMARY_SUB_ACCOUNT, LENDER_SUB_ACCOUNT] as const;

export interface StonexAccountOption {
  id: string;
  label: string;
}

// Master first (the default consolidated view), then each sub to drill in.
export const STONEX_ACCOUNT_OPTIONS: StonexAccountOption[] = [
  { id: MASTER_ACCOUNT, label: `Master · ${MASTER_ACCOUNT}` },
  ...SUB_ACCOUNTS.map((id) => ({ id, label: id })),
];
